import React, { Component } from "react";
import './mySkills.css';

import { ChangedData } from "../../assets/ChangedData/ChangedData";
import { SketchPicker } from "react-color";
import { AllData } from "../../Screens/Home";
import { skill } from "../../Screens/Home";





export function removeSkill(index){

};







class MySkills extends Component{

    /*
    SkillsData = [
        {
          "SkillsmainName" : "Office Paket",
          "SkillTitle" : "Microsoft Office Paket",
          "SkillsCards": [
            {
              "SkillName" : "Word",
              "color" : "#007bff" ,
              "SkillsRange" : "80%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/word_icon.svg" ,
            },
          
            {
              "SkillName" : "Powerpoint" ,
              "color" : "#cd664c" ,
              "SkillsRange" : "70%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/powerpoint_icon.svg" ,
            },
    
            {
              "SkillName" : "excel" ,
              "color" : "#33855d" ,
              "SkillsRange" : "50%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/excel_icon.svg" ,
            }, 
          ]
        },
    
        {
          "SkillsmainName" : "Programmieren",
          "SkillTitle" : "Programmiersprachen",
          "SkillsCards": [
            {
              "SkillName" : "PHP",
              "color" : "#8c94bc" ,
              "SkillsRange" : "75%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/php.svg" ,
            },
          
            {
              "SkillName" : "JavaScript" ,
              "color" : "#f3db4c" ,
              "SkillsRange" : "70%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/javaScript.svg" ,
            },
          
            {
              "SkillName" : "Java" ,
              "color" : "#5484a4" ,
              "SkillsRange" : "15%",
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/Java.svg" ,
            }, 
          ]
        },
    
        {
          "SkillsmainName" : "Web Skills" ,
          "SkillTitle" : "Web Skills" ,
          "SkillsCards": [
            {
              "SkillName" : "HTML/CSS",
              "color" : "#ff6c39" ,
              "SkillsRange" : "80%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/HTML-CSS.svg" ,
            },
    
            {
              "SkillName" : "Reactjs" ,
              "color" : "#00d8ff" ,
              "SkillsRange" : "75%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/ReactJs.svg" ,
            },
          
            {
              "SkillName" : "Angular" ,
              "color" : "#e00434" ,
              "SkillsRange" : "55%",
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/angular.svg" ,
            }, 
          ],
        },
        
        {
          "SkillsmainName" : "Graphic Design",
          "SkillTitle" : "Graphic Design",
          "SkillsCards": [
              {
              "SkillName" : "Illustrator",
              "color" : "#fa7b04" ,
              "SkillsRange" : "60%" ,
              "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/A-ills.svg" ,
              },
              {
                "SkillName" : "Figma" ,
                "color" : "#0ccc84" ,
                "SkillsRange" : "50%" ,
                "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/Figma.svg" ,
              },
              {
                "SkillName" : "XD" ,
                "color" : "#7a506d" ,
                "SkillsRange" : "85%",
                "SkillLogo" : "https://oderasid.com/myWebSiteSRC/Icons/A-XD.svg" ,
              }, 
          ],
        },

      ];

    SkillsRender =  <div>
                        { this.SkillsData.map( SkillDiv => 
                            <div>
                                <h4 className="SkillTitleTop"> {SkillDiv.SkillTitle} </h4>
                                <div className="ScillCardsDivRoute" id={SkillDiv.SkillTitle}></div>
                                <div className="MircrosoftSkills allSkillsContainerMain">
                                <div className="SkillsCardsContainer d-flex justify-content-between align-items-center" id="Microsoft" >
                                { SkillDiv.SkillsCards.map( SkillCard => 
                                    <div className="SKillCard">
                                        <div className="skLogoCONTAINER d-flex justify-content-center align-items-center">
                                            <img src={SkillCard.SkillLogo} className="SKLogoImag" alt="Word" />
                                        </div>
                                        <div className="sKillScardLableContainer d-flex justify-content-center align-items-center ">
                                            <span className="sKillScardLable"> { SkillCard.SkillName } </span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="ProgresBarsContainer">  
                                { SkillDiv.SkillsCards.map( SkillCard => 
                                    <div className="skillProgBarContainer d-flex flex-column justify-content-between">
                                        <div  className="d-flex"> <span className="skillProgBarLable">{ SkillCard.SkillName }</span><span className="skillProgBarLable">{ SkillCard.SkillsRange }</span> </div>
                                        <div className="skillProgBar"> <div className="skillProgBarColor" style={ {width: SkillCard.SkillsRange , backgroundColor: SkillCard.color } }></div> </div>
                                    </div>

                                )}
                            </div>
                        </div>
                        </div>
                        )}
                    </div>;

*/

    Card_Index = 0
    Abschnitt_Index = 0

    constructor(){
        super();

        this.fetchSkillsData = this.fetchSkillsData.bind(this);
        this.toTextEditFunction = this.toTextEditFunction.bind(this);
        this.rangColorChange = this.rangColorChange.bind(this);

        this.state = {
            SkillsDatain : AllData.SkillsDatain ,
            RenderSkills : <div></div>,
            background: ""
        }

        window.addEventListener("resize" , ()=>{
            this.respoOnResizeFiexed();
        });
    }

    async fetchSkillsData(){
        const allFiles = ["SkillsData"];
        const stateKey = ["SkillsDatain"];

        await fetch(`${process.env.PUBLIC_URL}/mydata/`+ allFiles[0] + ".json").then((r) => r.json()).then((data) =>{
            this.state[stateKey[0]] = data;
            AllData["SkillsDatain"] = data;

            const TitlesArray = [];
            for (let i = 0; i < data.skis.length; i++) {
                TitlesArray.push(data.skis[i].SkillTitle)
            };
            AllData["SkillsTitles"] = TitlesArray;

        }).finally(()=>{
            this.RenderSkills();
            setTimeout(() => {
                this.allScroll();
            }, 1);

            if (localStorage.getItem("isLogged") == "true") {
            }
        });
    }

    componentDidMount(){
        this.fetchSkillsData();
        window.addEventListener("DOMContentLoaded" , ()=>{
            this.ScroolspyActive();

            const OkButtonSkills = document.querySelector("#OkButtonSkills");
            OkButtonSkills.addEventListener("click" , ()=>{
                setTimeout(() => {
                    this.state.SkillsDatain.skis.push(skill);
                    this.RenderSkills();
                }, 300);
            });

            if (localStorage.getItem("isLogged") == "true") {
                setTimeout(() => {
                    const RemoveSK = document.getElementsByClassName("RemoveSK");
                    for (let I = 0; I < RemoveSK.length; I++) {
                        RemoveSK[I].addEventListener("click" , ()=>{
                            setTimeout(() => {
                                this.RenderSkills();
                            }, 10);
                        });
                    }
                }, 1200);
            }
        });

    }

    componentWillUnmount(){

    }

    ProgBars(){
        let skillProgBarColorS = document.querySelectorAll(".skillProgBarColor");
        let windowH = window.innerHeight;
        for (let i = 0; i < skillProgBarColorS.length; i++) {
            let top = skillProgBarColorS[i].getBoundingClientRect().top;
            if (top < windowH / 1.09) {
                skillProgBarColorS[i].classList.add("skillProgBarColorActive");
            }
        }
    }

    respoOnResizeFiexed(){
        // Dom Elements
        let ScrollspyItems = document.getElementById("ScrollspyItems");
        let ScrollspyContainer = document.getElementById("ScrollspyContainer");
        // Elements Position
        let ItemsPosition = ScrollspyItems.getBoundingClientRect();
        let ScrollspyContainerPos = ScrollspyContainer.getBoundingClientRect();

        if (ScrollspyContainerPos.top < 80 && ScrollspyContainerPos.bottom > ItemsPosition.height + 240) {
            ScrollspyItems.style.left = ScrollspyContainerPos.left + "px";
        }
       
        if ( window.innerWidth < 630) {
            ScrollspyItems.style.position = "relative";
        }
    }

    FiexedScrollspyElements(){
        // Dom Elements
        let ScrollspyItems = document.getElementById("ScrollspyItems");
        let ScrollspyContainer = document.getElementById("ScrollspyContainer");
        let SkillsInContainer = document.getElementById("SkillsInContainer");
        // Elements Position
        let ItemsPosition = ScrollspyItems.getBoundingClientRect();
        let ScrollspyContainerPos = ScrollspyContainer.getBoundingClientRect();
        let SkillsInContainerPos = SkillsInContainer.getBoundingClientRect();

        if (ScrollspyContainerPos.top < 80 && ScrollspyContainerPos.bottom > ItemsPosition.height + 240 && window.innerWidth > 630) {
            ScrollspyItems.style.position = "fixed";
            ScrollspyItems.style.top = 130 + "px";
            ScrollspyItems.style.left = ScrollspyContainerPos.left + "px";
            
        }else if(ScrollspyContainerPos.top > 80 && window.innerWidth > 630) {
            ScrollspyItems.style.position = "absolute";
            ScrollspyItems.style.top = "50px";
            ScrollspyItems.style.left = 0; 
        }else{
            if (window.innerWidth > 630) {
                ScrollspyItems.style.position = "absolute";
                ScrollspyItems.style.bottom = "110px";
                ScrollspyItems.style.left = "0px";
            }
        }

        if (ScrollspyContainerPos.bottom < 400) {
           
        }

        /*
        if(ScrollspyContainerPos.top < 140 && ScrollspyContainerPos.bottom > ItemsPosition.bottom ){
            ScrollspyItems.style.position = "fixed";
            ScrollspyItems.style.top = 140 + "px";
            ScrollspyItems.style.left = ScrollspyContainerPos.left + "px";
        }else{
            ScrollspyItems.style.position = "absolute";
            ScrollspyItems.style.bottom = 120 + "px";
            ScrollspyItems.style.left = 0;
        }


        if(ScrollspyContainerPos.top > 140){
            ScrollspyItems.style.position = "relative";
            ScrollspyItems.style.top = 0;
            ScrollspyItems.style.left = 0;   
        }


        /*

        if (SkillsInContainerPos.bottom - 80 < ItemsPosition.bottom ) {
            ScrollspyItems.style.position = "relative";
            ScrollspyItems.style.bottom = 120 + "px";
            ScrollspyItems.style.left = 0;
        }

        */
        
    }
    
    ScroolspyActive(){
        let InSideView = window.innerHeight / 2 + 80; 
        let MircrosoftSkills = document.querySelectorAll(".MircrosoftSkills");
        let scrollspyLable = document.querySelectorAll(".scrollspyLable");
        let ScrollspyItems = document.getElementById("ScrollspyItems");


        for (let index = 0; index < MircrosoftSkills.length; index++) {
            if (MircrosoftSkills[index].getBoundingClientRect().top <= InSideView && MircrosoftSkills[index].getBoundingClientRect().top > 0 ) {
                for (let i = 0; i < scrollspyLable.length; i++) {
                    scrollspyLable[i].classList.remove("scrollspyLableActive");
                }
                scrollspyLable[index].classList.add("scrollspyLableActive");
            }

            if (ScrollspyItems.getBoundingClientRect().top >= InSideView ) {
                for (let i = 0; i < scrollspyLable.length; i++) {
                    scrollspyLable[i].classList.remove("scrollspyLableActive");
                }
            }
        }
        

    }

    SKillCardAnimations(){
        let SkillsCardsContainer = document.querySelectorAll(".SkillsCardsContainer");
        let WindowH = window.innerHeight;
        let index = 0;

        function myLoop(){
            if (index < SkillsCardsContainer.length){
                if (SkillsCardsContainer[index].getBoundingClientRect().top < WindowH - 50) {
                    mackeAnimation(index);
                }
                index++;
                myLoop();
            }
        }
        myLoop();


        function mackeAnimation(elementIndex){
            let childs = SkillsCardsContainer[elementIndex].childNodes;
            let childernLength = SkillsCardsContainer[elementIndex].childNodes.length
            let index = 0;
            setTimeout(() => {
                myLoopChild();
            }, 100);
            function myLoopChild(){
                if (index < childernLength){
                    childs[index].style.transform = "translateY(0px)";
                    childs[index].style.opacity = 1;
                    index++;
                    setTimeout(() => {
                        myLoopChild();
                    }, 150);
                }
            }
        }
    }

    allScroll(){
        window.addEventListener("scroll" , ()=>{
            let windowH = window.innerHeight;
            let SkillsTop = document.getElementById("SkillsScreen").getBoundingClientRect().top;
            let SkillsBottom = document.getElementById("SkillsScreen").getBoundingClientRect().bottom;

            this.FiexedScrollspyElements();
            if (SkillsTop < windowH/1.1 && SkillsBottom > windowH/2){
                this.ScroolspyActive();
                this.SKillCardAnimations();
                this.ProgBars();
            }
        });
    }

    hoverEditOn(event){
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    hoverEditOut(event){
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }

    RenderSkills(){
        const renders =     <div className="SkillsScreen d-flex justify-content-center" id="SkillsScreen">
                                    <div id="Skills" className="ScreenRouteDiv"></div>
                                    <div className="SkillsScreen d-flex justify-content-center" id="SkillsScreen">

                                        
                                        {
                                        <div className="SkillsDiv d-flex justify-content-center">
                                            <div className="ScrollspyContainer d-flex flex-column align-items-start" id="ScrollspyContainer">
                                                <div className="ScrollspyItems" id="ScrollspyItems">
                                                    { this.state.SkillsDatain.skis.map( SkillMainTitle =>
                                                        <a href={"#"+SkillMainTitle.SkillTitle}><p className="scrollspyLable"> {SkillMainTitle.SkillTitle} </p></a>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="SkillsInContainer" id="SkillsInContainer">
                                            <div>
                                                { this.state.SkillsDatain.skis.map( (SkillDiv , mainindex) => 
                                                    <div>
                                                        <h4 className="SkillTitleTop" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} data-f="SkillsData" id={"t" + mainindex}> {SkillDiv.SkillTitle} </h4>
                                                        <div className="ScillCardsDivRoute" id={SkillDiv.SkillTitle}></div>
                                                        <div className="MircrosoftSkills allSkillsContainerMain">
                                                        <div className="SkillsCardsContainer d-flex justify-content-start align-items-center" id="Microsoft" >
                                                        { SkillDiv.SkillsCards.map( (SkillCard , i) => 
                                                            <div className="SKillCard" style={ SkillCard.SkillLogo ? { } : { height: 0 , paddingTop: 35 , paddingBottom: 60 } }>
                                                                <div  className="skLogoCONTAINER d-flex justify-content-center align-items-center" style={ SkillCard.SkillLogo ? { } : { height: 0 } } >
                                                                    { SkillCard.SkillLogo ?  <img src={SkillCard.SkillLogo} className="SKLogoImag" alt="logo" onClick={this.openDropFContainer} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} />  : ""  }
                                                                </div>
                                                                <div className="sKillScardLableContainer d-flex justify-content-center align-items-center " >
                                                                    <span className="sKillScardLable" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} data-f="SkillsData" id={"s" + mainindex + "_" + i} > { SkillCard.SkillName } </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="ProgresBarsContainer">  
                                                        { SkillDiv.SkillsCards.map( (SkillCard , i) => 
                                                            <div className="skillProgBarContainer d-flex flex-column justify-content-between">
                                                                <div  className="d-flex"> <span className="skillProgBarLable"  >{ SkillCard.SkillName }</span><span className="skillProgBarLable" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} data-f="SkillsData" id={"r" + mainindex + "_" + i}>{ SkillCard.SkillsRange }</span> </div>
                                                                <div className="skillProgBar"  onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} onClick={this.rangColorChange} id={mainindex + "_" + i} > <div className="skillProgBarColor" id={mainindex + "_" + i} style={  this.proz(SkillCard) }></div> </div>
                                                            </div>

                                                        )}
                                                    </div>
                                                    </div>
                                                    </div>
                                                )}
                                            </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                            </div>
        this.setState({
            RenderSkills : renders
        });
    }

    proz(SkillCard){
        let rang = SkillCard.SkillsRange;
        if (rang.search("%") <= 0) {
            rang = rang + "%"
        }
        return {width: rang , backgroundColor: SkillCard.color }
    }

    toTextEditFunction(event){
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {

                if ( textArea.value.length > 0) {
                    let NewValueTextarea = textArea.value;
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = event.target.getAttribute("data-f");
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;

                    if (atributname[0] == "s") {
                        for (let i = 0; i < atributname.length; i++) {
                            if (atributname[i] == "_") {
                                let Abschnitt_Index = atributname.substring(1 , i);
                                let Card_Index = atributname.substring(i + 1 , atributname.index);
                                if (Oldtext != textafter) {
                                    let SaveChangContainer = document.getElementById("SaveChangContainer");
                                    SaveChangContainer.style.visibility = "visible";
                                    this.state.SkillsDatain.skis[Abschnitt_Index].SkillsCards[Card_Index].SkillName = textafter;
                                    ChangedData[APIfileName] = this.state.SkillsDatain;
                                    this.RenderSkills();
                                }
                            }
                        }
                    }

                    if (atributname[0] == "r") {
                        if (Oldtext != textafter) {
                            for (let i = 0; i < atributname.length; i++) {
                                if (atributname[i] == "_") {
                                    let Abschnitt_Index = atributname.substring(1 , i);
                                    let Card_Index = atributname.substring(i + 1 , atributname.index);
                                    let SaveChangContainer = document.getElementById("SaveChangContainer");
                                    SaveChangContainer.style.visibility = "visible";
                                    this.state.SkillsDatain.skis[Abschnitt_Index].SkillsCards[Card_Index].SkillsRange = textafter;
                                    ChangedData[APIfileName] = this.state.SkillsDatain;
                                    this.RenderSkills();
                                }
                            }
                        }
                    }

                    if (atributname[0] == "t") {
                        var Abschnitt_Index = atributname.substring(1 , atributname.length);
                        if (Oldtext != textafter) {
                            let SaveChangContainer = document.getElementById("SaveChangContainer");
                            SaveChangContainer.style.visibility = "visible";
                            this.state.SkillsDatain.skis[Abschnitt_Index].SkillTitle = textafter;
                            ChangedData[APIfileName] = this.state.SkillsDatain;
                            this.RenderSkills();
                        }
                    }
                    
                }else{
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
    }

    handleChangeComplete = (color) => {
        this.setState({ background: color.hex });

        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";

        this.state.SkillsDatain.skis[this.Abschnitt_Index].SkillsCards[this.Card_Index].color = color.hex;
        ChangedData["SkillsData"] = this.state.SkillsDatain;
        this.RenderSkills();
    };

    rangColorChange(event){
        if (localStorage.getItem("isLogged") == "true") {
            const element = event.target;
            const Dimensions = element.getBoundingClientRect();
            let top = Dimensions.top;
            const height = Dimensions.height;
            top = height + top;

            var e = window.event;
            var posX = e.clientX;

            const SketchPicker = document.getElementById("SketchPicker");
            SketchPicker.classList.remove("SketchPickerAus");

            SketchPicker.style.position = "fixed";
            SketchPicker.style.top = top - 5 + "px";
            SketchPicker.style.left = posX + "px";

            SketchPicker.addEventListener( "mouseleave" , ()=>{
                SketchPicker.classList.add("SketchPickerAus");
            });

            for (let i = 0; i < element.id.length; i++) {
                if (element.id[i] == "_") {
                    let AbschnittIndex = element.id.substring(0 , i);
                    let CardIndex = element.id.substring(i + 1 , element.id.index);

                    this.Abschnitt_Index = AbschnittIndex;
                    this.Card_Index =  CardIndex;
                    /*
                    this.state.SkillsDatain.skis[Abschnitt_Index].SkillsCards[Card_Index].color = textafter;
                    ChangedData[APIfileName] = this.state.SkillsDatain;
                    this.RenderSkills();
                    */
                }
            }

            this.setState({ background: this.state.SkillsDatain.skis[this.Abschnitt_Index].SkillsCards[this.Card_Index].color });
        }
    }

    openDropFContainer(){
        if (localStorage.getItem("isLogged") == "true") {
            const DropFileContainer = document.getElementById("DropFileContainer");
            DropFileContainer.classList.remove("DropFileContainerZu");
    
            const DropFileBG = document.getElementById("DropFileBG");
            const BodyVisableZu = document.getElementById("BodyVisableZu");
    
            setTimeout(() => {
                DropFileBG.classList.remove("DropFileBGZu");
            }, 10);
    
            setTimeout(() => {
                BodyVisableZu.classList.remove("BodyVisableZu");
            }, 300);
        }
    }

   



    























    render(){
        return(
            <div>
                <div id="Skills" className="ScreenRouteDiv"></div>
                    { this.state.RenderSkills }
                    <div className="SketchPickerAus" id="SketchPicker">
                        <SketchPicker color={ this.state.background } onChangeComplete={ this.handleChangeComplete } /> 
                    </div>
            </div>
        );
    }

}


export default MySkills;




















/*
<div className="SkillsScreen d-flex justify-content-center" id="SkillsScreen">

    <div className="SkillsDiv d-flex justify-content-center">
        <div className="ScrollspyContainer d-flex flex-column align-items-start" id="ScrollspyContainer">
            <div className="ScrollspyItems" id="ScrollspyItems">
                { this.SkillsData.map( SkillMainTitle =>
                    <a href={"#"+SkillMainTitle.SkillsmainName}><p className="scrollspyLable"> {SkillMainTitle.SkillsmainName} </p></a>
                )}
            </div>
        </div>
        <div className="SkillsInContainer" id="SkillsInContainer">
            { this.SkillsRender }
        </div>
    </div>

</div>
*/